// extracted by mini-css-extract-plugin
export default {"msg_chairman_main":"MessageFromChairman_msg_chairman_main__g0Muz","msg_chairman_text":"MessageFromChairman_msg_chairman_text__xSZwy"};